import { gql } from "@apollo/client/core";

export const GET_EXTRACT_HIERARCHY_INFO = gql`
  query {
    extractHierarchy {
      extractHierarchyInfo {
        id
        name
      }
    }
  }
`;

export const GET_EXTRACT_HIERARCHY_DETAILS = gql`
  query extractHierarchyDetail($extractId: Int!) {
    extractHierarchy {
      extractHierarchyDetail(extractId: $extractId) {
       dimension
       extractID
       extractName
       properties
       includePath
       includeKey
       includeShared
       order 
       members{
         memberID
         relationship
         includeExclude
       }
      }
    }
  }
`;